<template>
  <b-carousel
    class="loc-type-carousel"
    v-model="slide"
    :interval="4000"
    controls
    indicators
  >
    <b-carousel-slide v-for="(t, i) in tasks" :key="i">
      <template #img>
        <div
          class="loc-type-carousel-image"
          :style="
            `background: url('${t.defaultAttachmentUrl}?w=1920&h=800&mode=crop');
            height: 80vh !important;
            `
          "
        >
          <!-- <div class="carousel-overlay">
            <div class="overlay-content">
              <p class="overlay-subtitle">
                {{ t.createdDate | moment("YYYY.MM.DD") }}
              </p>
              <div class="overlay-text">
                <p>
                  {{ t.task }}
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      slide: 0,
      sliding: null
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.loc-type-carousel {
  height: 80vh !important;

  .carousel-inner {
    height: 80vh !important;
  }

  .carousel-item {
    height: 80vh !important;
  }
  .loc-type-carousel-image {
    height: 80vh !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center top !important;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .carousel-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background: linear-gradient(45deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3));
    display: flex;
    align-items: end;
    justify-content: flex-end;
    padding: 30px;
  }

  .overlay-content {
    max-width: 600px;
    color: white;
    text-align: right;
    background: rgba(0, 0, 0, 0.5);
    padding: 20px;
    border-radius: 10px;
    backdrop-filter: blur(5px);
  }

  .overlay-title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 10px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    color: #fff;
  }

  .overlay-subtitle {
    font-size: 1rem;
    margin-bottom: 10px;
    color: #f0f0f0;
    font-weight: 500;
  }

  .overlay-text {
    font-size: 1.1rem;
    line-height: 1.2;
    color: #e0e0e0;
    p {
      margin: 0;
    }
  }

  .carousel-control-prev {
    .carousel-control-prev-icon {
      display: inline-block !important;
      width: 20px !important;
      height: 20px !important;
      background: 50%/100% 100% no-repeat !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
    }
  }
  .carousel-control-next {
    .carousel-control-next-icon {
      display: inline-block !important;
      width: 20px !important;
      height: 20px !important;
      background: 50%/100% 100% no-repeat !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
    }
  }

  // Responsive design
  @media (max-width: 768px) {
    .carousel-overlay {
      padding: 30px 20px;
      justify-content: center;
    }

    .overlay-content {
      max-width: 100%;
      text-align: center;
      padding: 30px 20px;
    }

    .overlay-title {
      font-size: 1.8rem;
    }

    .overlay-subtitle {
      font-size: 1.2rem;
    }

    .overlay-text {
      font-size: 1rem;
    }
  }
}
</style>
